import { reactive, ref, computed, provide } from 'vue';

// bot_config arrives as a (possibly reactive) JSONB document — round-trip through
// JSON so the draft is a plain object reactivity can handle.
export const cloneConfig = config => JSON.parse(JSON.stringify(config || {}));

const setPath = (obj, path, value) => {
  const keys = path.split('.');
  let target = obj;
  keys.slice(0, -1).forEach(key => {
    if (typeof target[key] !== 'object' || target[key] === null) {
      target[key] = {};
    }
    target = target[key];
  });
  target[keys[keys.length - 1]] = value;
};

export const getPath = (obj, path) =>
  path.split('.').reduce((acc, key) => acc?.[key], obj);

// Shared editing state for one bot_config. A Studio tab creates it and hands it to
// ConfigForm, so the tab's own setup code and the form edit the same draft.
export const createConfigDraft = bot => {
  const draft = reactive(cloneConfig(bot.bot_config));
  const baseline = ref(JSON.stringify(draft));
  const fieldErrors = reactive({});
  const generalError = ref('');
  const isDirty = computed(() => JSON.stringify(draft) !== baseline.value);

  const setValue = (field, value) => {
    let next = value;
    if (field.type === 'number') {
      next = value === '' || value === undefined ? null : Number(value);
    }
    setPath(draft, field.path, next);
    delete fieldErrors[field.path];
  };

  const fieldError = path => fieldErrors[path] || '';

  const replaceDraft = config => {
    Object.keys(draft).forEach(key => delete draft[key]);
    Object.assign(draft, cloneConfig(config));
    baseline.value = JSON.stringify(draft);
  };

  return {
    draft,
    baseline,
    fieldErrors,
    generalError,
    isDirty,
    setValue,
    fieldError,
    replaceDraft,
  };
};

export const provideConfigDraft = state => {
  provide('aiBotConfigDraft', state.draft);
  provide('aiBotConfigSetValue', state.setValue);
  provide('aiBotConfigErrorFor', state.fieldError);
};
